/* eslint sort-keys: ["error", "asc", {natural: true}] */

import { configureStore } from '@reduxjs/toolkit';
import contentTagSliceReducer, {
  CONTENT_TAG_READ_STORE_NAME,
} from 'redux/content-tag-read/content-tag-read.slice';
import layoutCopyReadSliceReducer, { LAYOUT_COPY_READ_STORE_NAME } from 'redux/layout-copy-read/layout-copy-read.slice';
import layoutCopyUpdateSliceReducer, { LAYOUT_COPY_UPDATE_STORE_NAME } from 'redux/layout-copy-update/layout-copy-update.slice';
import gadgetReadSliceReducer, { GADGET_READ_STORE_NAME } from './gadget-read/gadget-read.slice';
import layoutReadSliceReducer, { LAYOUT_READ_STORE_NAME } from './layout-read/layout-read.slice';
import myShortcutReadReducer, { MY_SHORTCUT_READ_STORE_NAME } from './my-shortcut-read/my-shortcut-read.slice';
import projectDetailReadReducer, {
  PROJECT_DETAIL_READ_STORE_NAME,
} from './project-detail-read/project-detail-read.slice';
import projectInviteeReadSliceReducer, {
  PROJECT_INVITEE_READ_STORE_NAME,
} from './project-invitee-read/project-invitee-read.slice';
import projectReadSliceReducer, {
  PROJECT_READ_STORE_NAME,
} from './project-read/project-read.slice';
import userReadSliceReducer, {
  USER_READ_STORE_NAME,
} from './user-read/user-read.slice';
import layoutupdateSliceReducer, {
  LAYOUT_UPDATE_STORE_NAME,
} from './layout-update/layout-update.slice';
import gadgetUpdateSliceReducer, {
  GADGET_UPDATE_STORE_NAME,
} from './gadget-update/gadget-update.slice';
import mainMenuReadSliceReducer, {
  MAIN_MENU_READ_STORE_NAME,
} from './main-menu-read/main-menu-read.slice';
import searchCriteriaReadReducer, {
  SEARCH_CRITERIA_READ_NAME,
} from './search-criteria-read/search-criteria-read.slice';
import notificationSliceReducer, {
  NOTIFICATION_STORE_NAME,
} from './notification/notification.slice';
import searchCriteriaUpdateSliceReducer, {
  SEARCH_CRITERIA_UPDATE_STORE_NAME,
} from './search-criteria-update/search-criteria-update.slice';
import extensiveAttributeDefinitionReadReducer, {
  EXTENSIVE_ATTRIBUTE_DEFINITION_READ_STORE_NAME,
} from './extensive-attribute-definition-read/extensive-attribute-definition-read.slice';
import searchResultGadgetReadSliceReducer, {
  SEARCH_RESULT_GADGET_READ_NAME,
} from './search-result-gadget-read/search-result-gadget-read.slice';
import unusedRoleReadSliceReducer, {
  UNUSED_ROLE_READ_STORE_NAME,
} from './unused-role-read/unused-role-read.slice';
import mainMenuUpdateSliceReducer, {
  MAIN_MENU_UPDATE_STORE_NAME,
} from './main-menu-update/main-menu-update.slice';
import viewPatternReadSliceReducer, {
  VIEW_PATTERN_READ_STORE_NAME,
} from './view-pattern-read/view-pattern-read.slice';
import extensiveAttributeDefinitionCreateReducer, {
  EXTENSIVE_ATTRIBUTE_DEFINITION_CREATE_STORE_NAME,
} from './extensive-attribute-definition-create/extensive-attribute-definition-create.slice';
import extensiveAttributeDefinitionUpdateReducer, {
  EXTENSIVE_ATTRIBUTE_DEFINITION_UPDATE_STORE_NAME,
} from './extensive-attribute-definition-update/extensive-attribute-definition-update.slice';
import extensiveAttributeValueCreateSliceReducer, {
  EXTENSIVE_ATTRIBUTE_VALUE_CREATE_STORE_NAME,
} from './extensive-attribute-value-create/extensive-attribute-value-create.slice';
import extensiveAttributeValueUpdateSliceReducer, {
  EXTENSIVE_ATTRIBUTE_VALUE_UPDATE_STORE_NAME,
} from './extensive-attribute-value-update/extensive-attribute-value-update.slice';
import extensiveAttributeValueDeleteSliceReducer, {
  EXTENSIVE_ATTRIBUTE_VALUE_DELETE_STORE_NAME,
} from './extensive-attribute-value-delete/extensive-attribute-value-delete.slice';
import layoutDeleteSliceReducer, {
  LAYOUT_DELETE_STORE_NAME,
} from './layout-delete/layout-delete.slice';
import layoutCreateSliceReducer, {
  LAYOUT_CREATE_STORE_NAME,
} from './layout-create/layout-create.slice';
import layoutNameUpdateSliceReducer, {
  LAYOUT_NAME_UPDATE_STORE_NAME,
} from './layout-name-update/layout-name-update.slice';
import roleCreateSliceReducer, {
  ROLE_CREATE_STORE_NAME,
} from './role-create/role-create.slice';
import roleDeleteSliceReducer, {
  ROLE_DELETE_STORE_NAME,
} from './role-delete/role-delete.slice';
import defaultProjectUpdateSliceReducer, {
  DEFAULT_PROJECT_UPDATE_STORE_NAME,
} from './default-project-update/default-project-update.slice';
import defaultLayoutUpdateSliceReducer, {
  DEFAULT_LAYOUT_UPDATE_STORE_NAME,
} from './default-layout-update/default-layout-update.slice';
import downloadHistoryReadSliceReducer, {
  DOWNLOAD_HISTORY_READ_STORE_NAME,
} from './download-history-read/download-history-read.slice';
import newArrivalNotificationUpdateReducer, {
  NEW_ARRIVAL_NOTIFICATION_UPDATE_STORE_NAME,
} from './new-arrival-notification-update/new-arrival-notification-update.slice';
import followFileDownloadReducer, {
  FOLLOW_FILE_DOWNLOAD_STORE_NAME,
} from './file-download/file-download.slice';
import dataRackReadReducer, {
  DATA_RACK_READ_STORE_NAME,
} from './data-rack-read/data-rack-read.slice';
import newArrivalNotificationReadStoreReducer, {
  NEW_ARRIVAL_NOTIFICATION_READ_STORE_NAME,
} from './new-arrival-notification-read-store/new-arrival-notification-read-store.slice';
import newArrivalNotificationUnreadStoreReducer, {
  NEW_ARRIVAL_NOTIFICATION_UNREAD_STORE_NAME,
} from './new-arrival-notification-unread-store/new-arrival-notification-unread-store.slice';

export const store = configureStore({
  reducer: {
    [CONTENT_TAG_READ_STORE_NAME]: contentTagSliceReducer,
    [DATA_RACK_READ_STORE_NAME]: dataRackReadReducer,
    [DEFAULT_LAYOUT_UPDATE_STORE_NAME]: defaultLayoutUpdateSliceReducer,
    [DEFAULT_PROJECT_UPDATE_STORE_NAME]: defaultProjectUpdateSliceReducer,
    [DOWNLOAD_HISTORY_READ_STORE_NAME]: downloadHistoryReadSliceReducer,
    [EXTENSIVE_ATTRIBUTE_DEFINITION_CREATE_STORE_NAME]: extensiveAttributeDefinitionCreateReducer,
    [EXTENSIVE_ATTRIBUTE_DEFINITION_READ_STORE_NAME]: extensiveAttributeDefinitionReadReducer,
    [EXTENSIVE_ATTRIBUTE_DEFINITION_UPDATE_STORE_NAME]: extensiveAttributeDefinitionUpdateReducer,
    [EXTENSIVE_ATTRIBUTE_VALUE_CREATE_STORE_NAME]: extensiveAttributeValueCreateSliceReducer,
    [EXTENSIVE_ATTRIBUTE_VALUE_DELETE_STORE_NAME]: extensiveAttributeValueDeleteSliceReducer,
    [EXTENSIVE_ATTRIBUTE_VALUE_UPDATE_STORE_NAME]: extensiveAttributeValueUpdateSliceReducer,
    [FOLLOW_FILE_DOWNLOAD_STORE_NAME]: followFileDownloadReducer,
    [GADGET_READ_STORE_NAME]: gadgetReadSliceReducer,
    [GADGET_UPDATE_STORE_NAME]: gadgetUpdateSliceReducer,
    [LAYOUT_COPY_READ_STORE_NAME]: layoutCopyReadSliceReducer,
    [LAYOUT_COPY_UPDATE_STORE_NAME]: layoutCopyUpdateSliceReducer,
    [LAYOUT_CREATE_STORE_NAME]: layoutCreateSliceReducer,
    [LAYOUT_DELETE_STORE_NAME]: layoutDeleteSliceReducer,
    [LAYOUT_NAME_UPDATE_STORE_NAME]: layoutNameUpdateSliceReducer,
    [LAYOUT_READ_STORE_NAME]: layoutReadSliceReducer,
    [LAYOUT_UPDATE_STORE_NAME]: layoutupdateSliceReducer,
    [MAIN_MENU_READ_STORE_NAME]: mainMenuReadSliceReducer,
    [MAIN_MENU_UPDATE_STORE_NAME]: mainMenuUpdateSliceReducer,
    [MY_SHORTCUT_READ_STORE_NAME]: myShortcutReadReducer,
    [NEW_ARRIVAL_NOTIFICATION_READ_STORE_NAME]: newArrivalNotificationReadStoreReducer,
    [NEW_ARRIVAL_NOTIFICATION_UNREAD_STORE_NAME]: newArrivalNotificationUnreadStoreReducer,
    [NEW_ARRIVAL_NOTIFICATION_UPDATE_STORE_NAME]: newArrivalNotificationUpdateReducer,
    [NOTIFICATION_STORE_NAME]: notificationSliceReducer,
    [PROJECT_DETAIL_READ_STORE_NAME]: projectDetailReadReducer,
    [PROJECT_INVITEE_READ_STORE_NAME]: projectInviteeReadSliceReducer,
    [PROJECT_READ_STORE_NAME]: projectReadSliceReducer,
    [ROLE_CREATE_STORE_NAME]: roleCreateSliceReducer,
    [ROLE_DELETE_STORE_NAME]: roleDeleteSliceReducer,
    [SEARCH_CRITERIA_READ_NAME]: searchCriteriaReadReducer,
    [SEARCH_CRITERIA_UPDATE_STORE_NAME]: searchCriteriaUpdateSliceReducer,
    [SEARCH_RESULT_GADGET_READ_NAME]: searchResultGadgetReadSliceReducer,
    [UNUSED_ROLE_READ_STORE_NAME]: unusedRoleReadSliceReducer,
    [USER_READ_STORE_NAME]: userReadSliceReducer,
    [VIEW_PATTERN_READ_STORE_NAME]: viewPatternReadSliceReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
